import { GameController } from "./GameController";

export default class PlayerController {
    gameController: GameController;
    experience: number;
    level: number;
    money: number;
    hunger: number;
    thirst: number;
    life: number;
    username: string;
    reference: any;
    position: any;
    inventory: {[key: string]: any};
    inventoryCurrentIndex: number | null = null;

    constructor(gameController: GameController){
        this.gameController = gameController;
        this.experience = 0;
        this.level = 1;
        this.money = 10;
        this.hunger = 5;
        this.thirst = 5;
        this.username = this.generateUsername();
        this.inventory = {};
        gameController.addEventHandler(["player:scrolled"], 'player-controller', this.onInventoryIndexChange);

        gameController.addEventHandler(["player:position:requested"], 'player-controller', (event, data) => {
            alert(`X: ${this.position.x}\nY: ${this.position.y}\nZ: ${this.position.z}`);
        });

    }

    start(){
        setInterval(()=>{
            this.setHunger(-1);
        }, 30000);

        setInterval(()=>{
            this.setThirst(-1);
        }, 20000);
    }
    setPlayerReference(reference: any){
        this.reference = reference;
    }

    generateUsername(){
        return "#"+(Math.random()).toString().substring(3,6);
    }

    setPosition(position: any){
        this.position = position;
    }

    addExperience(amount: number){
        this.experience += amount;
        if(this.experience >= this.getNextLevelThreshold()){
            this.level++;
            this.experience = 0;
        }
        this.gameController.sendEvent("player:updated", {experience: this.experience, level: this.level, money: this.money});
    }

    addMoney(amount: number){
        this.gameController.audio.playAudio('money',1);
        this.money += amount;
        this.gameController.sendEvent("player:updated", {experience: this.experience, level: this.level, money: this.money});
        this.gameController.sendEvent("player:money:updated", {amount: amount, total: this.money});
        this.gameController.setSceneState("money:taken");
    }

    useMoney(amount: number){
        this.money -= amount;
        this.gameController.sendEvent("player:updated", {experience: this.experience, level: this.level, money: this.money});
        this.gameController.sendEvent("player:money:updated", {amount: -amount, total: this.money});
    }

    getNextLevelThreshold(){
        return 10;
    }

    setHunger(val: number){
        this.hunger = Math.min(this.hunger + val, 5);
        if(this.hunger <= 0){
            this.gameController.gameOver();
        }
        this.gameController.sendEvent("player:updated", this);
        this.gameController.sendEvent("player:hunger:updated", {hunger: this.hunger});
    }

    setThirst(val: number){
        this.thirst = Math.min(this.thirst + val, 5);
        if(this.thirst <= 0){
            this.gameController.gameOver();
        }
        this.gameController.sendEvent("player:updated", this);
        this.gameController.sendEvent("player:thirst:updated", {thirst: this.thirst});
    }

    eat(item){
        this.gameController.audio.playAudio('eat',1);
        if(item){
            this.setHunger(item.data.food || 0);
            this.setThirst(item.data.drink || 0);
            this.removeItemFromInventory(item);
            setTimeout(()=>{
            this.gameController.audio.playAudio('voice_food',1, 1.1);
            }, 2000);
        }
    }

    drink(item){
        this.gameController.audio.playAudio('drink',1);
        if(item){
            this.setThirst(item.data.drink || 0);
            this.removeItemFromInventory(item);
            if(item.data.drunk){
                setTimeout(()=>{
                    document.querySelector("#game-canvas").classList.add("drunk");
                    this.gameController.audio.playAudio('voice_drunk',1, 1.1);
                    setTimeout(()=>{
                        document.querySelector("#game-canvas").classList.remove("drunk");
                    }, 15000);
                }, 3000);
            }
        }
    }

    use(item: any){
        if(item == null && this.inventoryCurrentIndex == null) return;
        item = item || Object.values(this.inventory)[this.inventoryCurrentIndex];
        if(item.data.type == "food"){
            this.eat(item);
        } else if(item.data.type == "drink"){
            this.drink(item);
        }
    }
    buy(key: string, amount: number, sceneState?: string){
        if(this.money < amount){
            this.gameController.audio.playAudio('error',0.3);
            return false;
        }
        this.gameController.audio.playAudio('buy',1);
        this.useMoney(amount);
        this.gameController.addElementToScene(key, [0,0.5,0]);
        if(sceneState){
            this.gameController.setSceneState(sceneState);
        }
        return true;
    }

    setUsername(username: string){
        this.username = username;
        this.gameController.sendEvent("username:updated", {username: username});
    }

    sleep(){
        this.gameController.setCurrentPlayerInteraction("sleep", {});
        this.gameController.audio.playAudio('sleep',0.5,1.5);
        setTimeout(()=>{
            this.gameController.setCurrentPlayerInteraction(null, {});
            this.gameController.audio.pauseAudio('sleep');
            //this.gameController.audio.playAudio('alarm',0.3,2);
        }, 3500);
    }

    pee(){
        this.gameController.setCurrentPlayerInteraction("toilet", {});
        this.gameController.audio.playAudio('pee',1,2.5);
        setTimeout(()=>{
            this.gameController.setCurrentPlayerInteraction(null, {});
        }, 2000);
    }

    removeItemFromInventory(item){
        delete this.inventory[item.uid];
        console.log("Inventory updated", this.inventory);
        this.gameController.sendEvent("inventory:updated", {inventory: this.inventory});
    }

    onInventoryUpdated(){
        if(this.inventoryCurrentIndex == null && Object.keys(this.inventory).length > 0){
            this.inventoryCurrentIndex = 0;
        }
    }

    onInventoryIndexChange = (event, data) => {
        if(Object.keys(this.inventory).length == 0) return;
        if(data.direction == "up"){
            this.inventoryCurrentIndex = this.inventoryCurrentIndex == 0 ? Object.keys(this.inventory).length - 1 : this.inventoryCurrentIndex - 1;
        } else {
            this.inventoryCurrentIndex = this.inventoryCurrentIndex == Object.keys(this.inventory).length - 1 ? 0 : this.inventoryCurrentIndex + 1;
        }
        this.gameController.sendEvent("inventory:updated", {index: this.inventoryCurrentIndex});
    }

    tryBuild(item){
        const requireItems = Object.entries(item.data.items).reduce((acc: any[], [key, value]) => {
            acc.push({ type: key, needed: value, found: [] });
            return acc;
        }, []);
        const items = Object.values(this.inventory);
        console.log(items);
        requireItems.forEach((requireItem, index, arr) => {
            items.forEach((item) => {
                console.log("ITEM", item, requireItem);
                if(item.key == requireItem.type && requireItem.found.length < requireItem.needed){
                    console.log("FOUND!!!!");
                    arr[index].found.push(item);
                }
            });
        });
        console.log("REQUIRE ITEMS", requireItems);
        // Check if all required items are found
        if(requireItems.some((requireItem: any) => requireItem.found.length < requireItem.needed)){
            this.gameController.audio.playAudio('error',0.3);
            return false;
        } else {
            requireItems.forEach((requireItem: any) => {
                requireItem.found.forEach((item) => {
                    this.removeItemFromInventory(item);
                });
            });
            return true;
        }
    }
}